module.exports = __webpack_public_path__ + "static/img/technologybimg5.1288817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/technologybimg5.jpg
// module id = sbUE
// module chunks = 2